import type { ISortCriteria } from "@/lib/shared/types/pagination";

const ALLOWED_CRITERIA = ["displayPrice", "priority", "updatedAt"] as const;

function isSortCriteria(criteria: string): criteria is ISortCriteria["criteria"] {
  return (ALLOWED_CRITERIA as readonly string[]).includes(criteria);
}

/** Options shown on product grid sort control (select value ↔ API sort). */
export const PRODUCT_GRID_SORT_OPTIONS: ISortCriteria[] = [
  { criteria: "displayPrice", order: "asc" },
  { criteria: "displayPrice", order: "desc" },
  { criteria: "priority", order: "asc" },
];

export function sortCriteriaToSelectValue(criteria: ISortCriteria): string {
  return `${criteria.criteria}-${criteria.order}`;
}

export function sortCriteriaFromSelectValue(value: string): ISortCriteria | null {
  const lastDash = value.lastIndexOf("-");
  if (lastDash <= 0) return null;
  const criteria = value.slice(0, lastDash);
  const order = value.slice(lastDash + 1);
  if (order !== "asc" && order !== "desc") return null;
  if (!isSortCriteria(criteria)) return null;
  return { criteria, order };
}
